import { ga } from 'js/analytics/adapters'

export const trackLogin = ({ method: login_method }) => {
  ga.track('log_in', { login_method })
}
